import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalCustomerSearchComponent } from './GlobalCustomerSearchComponent';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseDrawerModule } from '@fuse/components/drawer';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    GlobalCustomerSearchComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatTooltipModule,
    FuseDrawerModule,
    MatButtonModule,
    ReactiveFormsModule
  ],
  
  exports     : [
    GlobalCustomerSearchComponent
  ]
})
export class GlobalCustomerSearchModule
{
}

